import React from 'react'

const footerLinks = [
    {href: "https://privateshare.com/#rent", label: "Huur een voertuig"},
    {href: "https://privateshare.com/#host", label: "Verhuur een voertuig"},
    {href: "https://privateshare.com/#how-it-works-host", label: "Hoe werkt PrivateShare?"},
    {href: "https://privateshare.com/#contact", label: "Contact"},
]

const PrivateShareFooter = () => {
    return (
        <footer className="wl-privateshare-footer">
            <div className="container">
                <div className="wl-privateshare-footer__main">
                    <div className="wl-privateshare-footer__brand">
                        <a href="https://privateshare.com/" target="_top" className="wl-privateshare-footer__logoLink">
                            <img
                                className="wl-privateshare-footer__logo"
                                src="https://privateshare.com/img/-dlOI5E0x--321.jpeg"
                                alt="PrivateShare"
                            />
                        </a>
                        <p>Voertuigdelen veilig en volledig digitaal.</p>
                    </div>

                    <div className="wl-privateshare-footer__details">
                        <div className="wl-privateshare-footer__section">
                            <h2>PrivateShare B.V.</h2>
                            <address>
                                Klokkenbergweg 17<br/>
                                1101 AK Amsterdam<br/>
                                <span>T </span><a href="tel:+310880883435">088 - 088 34 35</a><br/>
                                <span>E </span><a href="mailto:info@privateshare.com">info@privateshare.com</a>
                            </address>
                        </div>

                        <div className="wl-privateshare-footer__section">
                            <h2>PrivateShare</h2>
                            <ul className="wl-privateshare-footer__links">
                                {footerLinks.map((link) => (
                                    <li key={link.href}>
                                        <a href={link.href} target="_top">{link.label}</a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default PrivateShareFooter
